// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/donation_common.css
// module id = W84i
// module chunks = 1